import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import NewsletterSubscribeForm from "components/Library/NewsletterSubscribeForm";
import FetchOnSubmit from "components/Library/FetchOnSubmit";
import NewsletterPromoSuccess from "components/Library/NewsletterPromoSuccess";

import { FETCH_STATUS } from "config/constants";

import styles from "./StoryNewsletterPromo.css";

export default function StoryNewsletterPromo({ promotion }) {
  return (
    <div
      className={classNames(styles.root)}
      style={{ backgroundColor: promotion.backgroundColor }}
    >
      <div className={styles.flex}>
        <div>
          <h3 className={styles.title}>{promotion.title}</h3>
          <p className={styles.description}>{promotion.content}</p>
        </div>
        {promotion.image && (
          <img className={styles.image} src={promotion.image} />
        )}
      </div>

      <FetchOnSubmit method="POST" url="/readers/unauth-sub/">
        {({ status, error, submit, reset }) => {
          return (
            <React.Fragment>
              <div aria-live="polite" role="status">
                {status === FETCH_STATUS.SUCCESS && (
                  <div
                    className={styles.successOverlay}
                    style={{ backgroundColor: promotion.backgroundColor }}
                  >
                    <NewsletterPromoSuccess />
                  </div>
                )}
              </div>
              <div aria-hidden={status === FETCH_STATUS.SUCCESS}>
                <NewsletterSubscribeForm
                  formClassName={classNames(
                    styles.form,
                    "gtm-newsletter-promo-in-story"
                  )}
                  userVars={{
                    campaign: "in_story_cta_direct_email_input",
                    requested_lists: promotion.list,
                  }}
                  list={promotion.list}
                  placeholder={promotion.placeholder}
                  status={status}
                  submit={submit}
                  reset={reset}
                  error={error}
                />
              </div>
            </React.Fragment>
          );
        }}
      </FetchOnSubmit>
    </div>
  );
}

StoryNewsletterPromo.propTypes = {
  promotion: PropTypes.shape({
    backgroundColor: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    image: PropTypes.string,
    list: PropTypes.string,
    placeholder: PropTypes.string,
  }).isRequired,
};
